<template>
	<layout-admin>
		<h1 class="text-3xl font-bold leading-tight text-gray-900">
			Preisindikation: Freischaltung von Landwirten
		</h1>
		<div class="w-full h-full relative">
			<!-- Legend -->
			<div class="absolute bg-white right-4 top-4 rounded-lg p-4 z-500 shadow">
				<ui-select
					class="block mb-4"
					v-model="currentGrp"
					:options="grpSelectOptions"
					:allow-empty="false"
				/>

				<div class="flex flex-col gap-y-4 items-start">
					<div
						class="flex gap-x-4 items-center"
						v-for="(bucket, idx) in mapData.buckets"
						:key="'BUCKET_LEGEND_' + idx"
					>
						<div class="inline-block headline rounded-full bg-gray-300 w-8 h-8">
							<div
								class="headline rounded-full bg-red-500 w-8 h-8"
								:style="'opacity:' + idx"
							></div>
						</div>
						<div>{{ __(bucket) }}</div>
					</div>
				</div>
			</div>
			<crop-map
				:should-fit-bounds="false"
				style="height: calc(100vh - 56px)"
				ref="map"
			>
				<template v-slot:other>
					<admin-map-marker
						v-for="(point, idx) in mapData.points"
						:key="'MARKER_' + idx + '_' + idx"
						:active-id="activeId"
						:point="point"
					/>
				</template>
			</crop-map>
		</div>
	</layout-admin>
</template>

<script>
import {
	map as lodashMap,
	min as lodashMin,
	max as lodashMax,
	uniq,
	chunk as lodashChunk,
	sortBy as lodashSortBy,
} from "lodash";
import { LMarker, LIcon, LPopup } from "vue2-leaflet";
export default {
	props: {
		users: {
			type: Array,
			required: true,
		},
	},
	components: {
		LMarker,
		LIcon,
		LPopup,
	},
	data() {
		let grpOptions = ["ALL", "NOT ACTIVE", "ACTIVE"];
		return {
			grpOptions: grpOptions,
			currentGrp: grpOptions[0],
			activeId: null,
		};
	},
	computed: {
		mapData() {
			let status = this.currentGrp == "ACTIVE" ? true : false;
			let filteredUsers =
				this.currentGrp == "ALL"
					? this.users
					: this.users.filter((user) => user.acl__price_indication == status);
			return {
				points: filteredUsers,
				buckets: ["NOT ACTIVE", "ACTIVE"],
			};
		},
		iconUrl() {
			return (
				window.baseUrl + "/images/leaflet-color-markers/img/circle-green.svg"
			);
		},
		grpSelectOptions() {
			return this.grpOptions.map(function (o) {
				return { id: o, name: o };
			});
		},
	},
	mounted() {
		let that = this;
		this.$root.$on("new-active-marker-id", function (newId) {
			console.log("NEW ACTIVE MARKER ID", newId);
			that.activeId = newId;
		});
	},
	methods: {
		fromGeoJson: function (geoJ) {
			return {
				lat: geoJ.coordinates[1],
				lng: geoJ.coordinates[0],
			};
		},
		toggleActive() {
			this.$root.$emit("new-active-marker-id", this.item.match_id);
		},
	},
};
</script>
